export function isShareSupported() {
    return navigator.share !== undefined
}

export function shareCurrentUrl() {
    navigator.share({
        url: window.location.href,
    })
}
